import primary from '@material-ui/core/colors/lightBlue';
import secondary from '@material-ui/core/colors/grey';

export default {
    palette: {
        primary: {
            ...primary,
            main: '#1498d5'
        },
        secondary,
        text: {
            secondary: "rgba(0, 0, 0, 0.87)",
            primary: "rgba(255, 255, 255, 0.87)"
        }
    },
    typography: {
        htmlFontSize: 10,
        fontFamily: '"Raleway", sans-serif',
        display4: {

        },
        display3: {

        },
        display2: {

        },
        display1: {
            fontWeight: 700,
            fontSize: "2rem"
        },
        headline: {
            textAlign: 'center',
            fontWeight: 'bold',
            color: '#244b63',
            fontSize: '3.6rem'
        },
        title: {
            fontWeight: 'bold',
            fontSize: '2rem',
            color: 'rgba(255, 255, 255, 0.87)',
        },
        subheading: {
            fontSize: '2rem',
            color: 'rgba(255, 255, 255, 0.87)',
        },
        body2: {
            fontSize: '2rem',
            color: 'rgba(255, 255, 255, 0.87)',
        },
        body1: {
            fontSize: '1.6rem',
            color: 'rgba(255, 255, 255, 0.87)',
        },
        caption: {
            fontSize: '1.6rem',
            color: 'rgba(255, 255, 255, 0.87)',
        },
        button: {
            fontFamily: '"Poppins", sans-serif',
            fontWeight: 700,
            fontSize: '1.6rem',
        }
    },
    overrides: {
        MuiFormHelperText: {
            root: {

            }
        },
        MuiFormLabel: {
            root: {
                color: "rgba(0, 0, 0, 0.87)",
            },
            focused: {

            }
        },
        MuiFormControlLabel: {
            label: {
                fontSize: '2rem',
                fontWeight: 400,
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/themes/index.js